import * as React from "react";
import { UitkIcon } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";

export enum ARROW_LINK_DIRECTION {
  LEFT = "left",
  RIGHT = "right"
}

export const ArrowLink = ({
  disabled,
  direction,
  onClick
}: {
  disabled: boolean;
  direction: string;
  onClick: (isLeftArrow: boolean) => (e: MouseEvent) => void;
}) => {
  const Icon = <UitkIcon name={`chevron_${direction}`} />;
  const isLeftArrow = direction === ARROW_LINK_DIRECTION.LEFT;
  const ariaLabel = isLeftArrow ? "previous" : "next";

  return (
    <UitkLink
      className={`uitk-cell all-cell-1-6 ${disabled ? "disabled" : ""} ${
        isLeftArrow ? "" : "all-grid-align-end"
      }`}
    >
      {disabled ? (
        <span aria-label={`${ariaLabel} disabled`}>{Icon}</span>
      ) : (
        <TrackedLink
          role="button"
          aria-label={ariaLabel}
          onClick={onClick(!isLeftArrow)}
          moduleName="tripCostEstimator"
          rfrr={`links-arrow-${direction}`}
        >
          {Icon}
        </TrackedLink>
      )}
    </UitkLink>
  );
};

export default ArrowLink;
